<template>
    <iframe class="simulation" ref="frame" :src="source" />
    <!-- :src="source" -->
</template>

<script>
    import store from '@/store';

    const target = process.env.VUE_APP_APPLICATION_URL

    const listener = event => {
        store.dispatch('chapters/interaction', event.data);
    };

    export default {
        name: 'Simulation',
        data(){
            return {
                queue: [],
                loaded: false
            };
        },
        props: {
            root: Boolean
        },
        computed: {
            product(){
                return this.$store.getters.product;
            },
            source(){
                // if(this.product.product_slug === 'anatomy'){
                //     return '/assets/0376b7fc-4f04-4406-a58c-996c87ece1a8/anatomy.html';
                // }

                return `/simulations/${this.product.product_slug}.html`;
            }
        },
        methods: {
            execute(event){
                if(this.loaded){
                    if(this.$refs.frame){
                        this.$refs.frame.contentWindow.postMessage(event, target);
                    }else{
                        console.error('No simulation frame loaded!');
                    }
                }else{
                    this.queue.push(event);
                }
            }
        },
        mounted(){
            this.mounted = true;

            this.$refs.frame.addEventListener('load', () => {
                this.loaded = true;

                //Execute all of the queued items.
                while(this.queue.length){
                    this.execute(this.queue.shift());
                }
            });

            //TODO Make sure this listener is removed when the component is destroyed
            if(this.root){
                window.addEventListener('message', listener);
            }

            if(this.root){
                this.$store.subscribeAction(action => {
                    if(action.type === 'chapters/simulation'){
                        this.execute(action.payload);
                    }
                });
            }
        },
        destroyed(){
            this.loaded = false;
            this.mounted = false;
            window.removeEventListener('message', listener);
        }
    }
</script>

<style scoped lang="less">
    @import "~@/assets/less/variables";

    .simulation
    {
        width: 100%;
        height: 100%;
    }
</style>
